import React from 'react';
import { useNavigate } from "react-router-dom";

import { Button, Form, Modal } from 'react-bootstrap';
import {IoIosArrowForward} from 'react-icons/io';

import '../EmailVerification.scss';

const CodeSuccessModal = (props: any) => {

  const navigate = useNavigate();
  const goHome = (): void => {
    window.location.replace('https://motorsportgames.com/')
  }

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      className='code-modal-container-lmu'
    >
      <img src="/lmu-logo-full.png" height="240" className="verify-logo-lmu" />
      <Modal.Header className="code-modal-header-lmu msg-header-text-lmu">
        <Modal.Title id="contained-modal-title-vcenter" className="msg-header-text-lmu code-modal-title">
          Account Verification Successful
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="code-modal-body-lmu msg-body-text-lmu">
        <div className="container msg-body-text-lmu">
          <div className="row msg-body-text-lmu">
            Thank you for verifying your e-mail address
          </div>
          <div className="row msg-body-text-lmu">
            You can now log in and participate online
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="code-modal-footer-lmu msg-body-text-lmu">
        <Button className="code-modal-submit-button msg-body-text-lmu"
          onClick={goHome}>
          <span>OK
            <IoIosArrowForward className="code-modal-submit-icon" size="0.75rem"/>
          </span>
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CodeSuccessModal;
